__turbopack_context__.v({
  "button-group": "p_LJAq_button-group",
  "enable-button": "p_LJAq_enable-button",
  "fade-button": "p_LJAq_fade-button",
  "group-options": "p_LJAq_group-options",
});
